export default {
  // Hero Section
  'hero.badge': 'Vārti uz Baltijas un Ziemeļeiropas Tirgu',
  'hero.title.line1': 'Preču Eksports ',
  'hero.title.highlight1': 'Āzijas',
  'hero.title.line2': 'uz',
  'hero.title.highlight2': 'Baltiju un Ziemeļeiropu',
  'hero.title.line3': 'Tirgus',
  'hero.description': 'The Daeg International Trade - Uzticams partneris, kas palīdz Āzijas uzņēmumiem piekļūt Baltijas un Ziemeļeiropas tirgum ar vairāk nekā 5 miljoniem iedzīvotāju caur Latviju. Izmantojiet loģistikas priekšrocības un zemas izmaksas Ziemeļeiropas segmentā.',
  'hero.stats.population': 'Baltijas un Ziemeļeiropas Iedzīvotāji',
  'hero.stats.experience': 'Gadu Pieredze',
  'hero.stats.locations': 'Izplatīšanas Centri',
  'hero.stats.support': 'Visaptveroša Atbalsts',
  'hero.cta.contact': 'Sazināties par Sadarbību',
  'hero.cta.learn': 'Uzzināt Vairāk',

  // Opportunity Section
  'opportunity.title': 'Kāpēc Eksportēt uz Baltiju un Ziemeļeiropu caur Latviju?',
  'opportunity.description': 'Latvija ir ideāli vārti Āzijas uzņēmumiem, lai piekļūtu Baltijas un Ziemeļeiropas tirgum ar vairāk nekā 30 miljoniem iedzīvotāju.',
  'opportunity.item1.title': 'Stratēģiskā Atrašanās Vieta',
  'opportunity.item1.desc': 'Latvija atrodas Baltijas centrā, ērti pieejama Igaunijas, Lietuvas un Ziemeļeiropas tirgiem.',
  'opportunity.item2.title': 'Zemas Loģistikas Izmaksas',
  'opportunity.item2.desc': 'Konkurētspējīgas loģistikas izmaksas salīdzinājumā ar citām Ziemeļeiropas valstīm, palīdzot optimizēt biznesa peļņu.',
  'opportunity.item3.title': 'Augošais Tirgus',
  'opportunity.item3.desc': 'Baltijas un Ziemeļeiropas tirgū ir vairāk nekā 30 miljoni iedzīvotāju ar augstu pirktspēju un pieaugošu pieprasījumu pēc Āzijas precēm.',
  'opportunity.item4.title': 'ES Dalībvalsts',
  'opportunity.item4.desc': 'Latvija ir ES dalībvalsts, viegli izplatīt preces visā Eiropas tirgū bez muitas barjerām.',

  'opportunity.latvia.title': 'Latvijas Priekšrocības',
  'opportunity.latvia.desc.short': 'Rīgas osta — viena no lielākajām ostām Baltijā. Darbības izmaksas <strong>par 30-40% zemākas</strong> nekā Ziemeļeiropā, palīdzot uzņēmumiem <strong>optimizēt izmaksas</strong>, piekļūstot tirgum ar vairāk nekā 30 miljoniem iedzīvotāju.',
  'opportunity.latvia.desc.full': 'Latvijai ir <strong>moderna loģistikas sistēma</strong> ar Rīgas ostu — vienu no lielākajām ostām Baltijas reģionā. Telpu nomas, darbaspēka un darbības izmaksas ir <strong>par 30-40% zemākas</strong> nekā Ziemeļeiropas valstīs, piemēram, Zviedrijā, Norvēģijā, Somijā. Tā ir liela konkurences priekšrocība uzņēmumiem, kas vēlas <strong>optimizēt izmaksas</strong>, vienlaikus piekļūstot bagātajam Ziemeļeiropas tirgum ar vairāk nekā 30 miljoniem iedzīvotāju.',

  // Services Section
  'services.title': 'Visaptverošie Eksporta Pakalpojumi',
  'services.description': 'Mēs piedāvājam pilnu risinājumu no importa, izplatīšanas līdz loģistikai un juridiskajam atbalstam.',
  'services.service1.title': 'Imports un Muita',
  'services.service1.desc': 'Profesionāli muitas pakalpojumi, nodrošinot ātru un likumīgu preču importu.',
  'services.service1.feature1': 'Muitas formalitāšu kārtošana',
  'services.service1.feature2': 'PVN un nodokļu konsultācijas',
  'services.service1.feature3': 'Produktu sertifikācijas atbalsts',
  'services.service1.feature4': 'Ātra apstrādes laiks',
  'services.service2.title': 'Izplatīšana caur Asian Alley',
  'services.service2.desc': 'Produktu izplatīšana caur mūsu Asian Alley un Cho Hem Kiosku sistēmu Rīgā.',
  'services.service2.feature1': '2 izplatīšanas centri',
  'services.service2.feature2': 'Izdevīgas atrašanās vietas',
  'services.service2.feature3': 'Daudzveidīga klientu bāze',
  'services.service2.feature4': 'Profesionāla vadība',
  'services.service3.title': 'Loģistika un Noliktavas',
  'services.service3.desc': 'Moderna noliktavu sistēma un profesionāli loģistikas pakalpojumi.',
  'services.service3.feature1': 'Droša uzglabāšana',
  'services.service3.feature2': 'Krājumu pārvaldība',
  'services.service3.feature3': 'Ātra piegāde',
  'services.service3.feature4': 'Konkurētspējīgas izmaksas',
  'services.service4.title': 'Juridiskās un Nodokļu Konsultācijas',
  'services.service4.desc': 'Juridiskās un nodokļu konsultāciju pakalpojumi, lai nodrošinātu atbilstību Latvijas un ES noteikumiem.',
  'services.service4.feature1': 'Uzņēmuma reģistrācija',
  'services.service4.feature2': 'Nodokļu konsultācijas',
  'services.service4.feature3': 'Līgumu atbalsts',
  'services.service4.feature4': 'Likumu ievērošana',
  'services.service5.title': 'Tirgus Izpēte',
  'services.service5.desc': 'Tirgus izpētes un analīzes pakalpojumi, lai palīdzētu jums saprast klientu vajadzības.',
  'services.service5.feature1': 'Tirgus analīze',
  'services.service5.feature2': 'Konkurentu izpēte',
  'services.service5.feature3': 'Cenu stratēģija',
  'services.service5.feature4': 'Tendenču prognoze',
  'services.service6.title': 'Atbalsts 24/7',
  'services.service6.desc': 'Mūsu atbalsta komanda ir gatava jums palīdzēt jebkurā laikā.',
  'services.service6.feature1': 'Daudzvalodu atbalsts',
  'services.service6.feature2': 'Ātra atbilde',
  'services.service6.feature3': 'Profesionālas konsultācijas',
  'services.service6.feature4': 'Ilgtermiņa partnerība',

  // Asian Alley Section
  'asianAlley.title': 'Asian Alley - Āzijas Preču Izplatīšanas Sistēma',
  'asianAlley.description': 'Asian Alley ir mūsu Āzijas preču izplatīšanas sistēma ar 2 vietām Rīgā, apkalpojot tūkstošiem klientu katru mēnesi.',
  'asianAlley.badge': 'Ekskluzīvs Izplatīšanas Kanāls',
  'asianAlley.subtitle': 'Vadošais Āzijas Veikals Rīgā',
  'asianAlley.description2': 'Asian Alley nav tikai mazumtirdzniecības vieta, bet arī <strong>dzīvs izstāžu zāle</strong>, kas palīdz partneriem pārbaudīt reālo tirgus atgriezenisko saiti, lai pielāgotu produktus Eiropas patērētāju gaumei un vajadzībām.',
  'asianAlley.callout.title': 'Ekskluzīva priekšrocība:',
  'asianAlley.callout.desc': 'The Daeg partneri saņem prioritāti izstādīšanai Asian Alley — vienīgajā Āzijas preču izplatīšanas kanālā Latvijā.',
  'asianAlley.stats.locations': 'Vietas',
  'asianAlley.stats.revenue': 'Gada Apgrozījums',
  'asianAlley.stats.customers': 'Klienti/Mēnesī',
  'asianAlley.stats.products': 'Produktu Kategorijas',
  'asianAlley.stats.locationsSub': 'Rīgas centrā',
  'asianAlley.stats.customersSub': 'Reālie patērētāji',
  'asianAlley.stats.productsSub': 'Daudzveidīgs sortiments',
  'asianAlley.stats.revenueSub': 'Stabila izaugsme',
  'asianAlley.cta': 'Uzzināt Vairāk par Asian Alley',

  // Process Section
  'process.title': 'Eksporta Process',
  'process.description': 'Vienkāršs un pārredzams process, kas palīdz jums viegli eksportēt preces uz Baltijas un Ziemeļeiropas tirgu.',
  'process.step1.title': 'Kontakts un Konsultācija',
  'process.step1.desc': 'Sazinieties ar mums, lai saņemtu detalizētas konsultācijas par produktiem un eksporta procesu.',
  'process.step2.title': 'Produktu Novērtējums',
  'process.step2.desc': 'Mēs novērtējam produktu un sniedzam tirgus analīzi, cenu stratēģiju.',
  'process.step3.title': 'Līguma Parakstīšana',
  'process.step3.desc': 'Parakstām sadarbības līgumu un vienojamies par noteikumiem.',
  'process.step4.title': 'Imports un Muita',
  'process.step4.desc': 'Mēs apstrādājam importa un muitas formalitātes.',
  'process.step5.title': 'Izplatīšana',
  'process.step5.desc': 'Produkti tiek izplatīti caur Asian Alley vai citiem kanāliem.',
  'process.step6.title': 'Maksājums un Atskaites',
  'process.step6.desc': 'Pārredzami maksājumi un detalizētas ikmēneša atskaites.',

  // Why Us Section
  'whyUs.title': 'Kāpēc Izvēlēties The Daeg International Trade?',
  'whyUs.description': 'Mēs esam uzticams partneris ar vairāk nekā 5 gadu pieredzi Āzijas preču eksporta jomā.',
  'whyUs.reason1.title': 'Bagāta Pieredze',
  'whyUs.reason1.desc': 'Vairāk nekā 5 gadu pieredze Āzijas preču eksporta un izplatīšanas jomā Baltijas un Ziemeļeiropas tirgū.',
  'whyUs.reason2.title': 'Gatava Izplatīšanas Sistēma',
  'whyUs.reason2.desc': 'Asian Alley izplatīšanas sistēma ar 2 vietām Rīgā un Liepājā, apkalpojot tūkstošiem klientu katru mēnesi.',
  'whyUs.reason3.title': 'Profesionāla Komanda',
  'whyUs.reason3.desc': 'Pieredzējusi komanda ar dziļām zināšanām par Baltijas un Ziemeļeiropas tirgu.',
  'whyUs.reason4.title': 'Konkurētspējīgas Izmaksas',
  'whyUs.reason4.desc': 'Konkurētspējīgas loģistikas un izplatīšanas izmaksas, palīdzot optimizēt biznesa peļņu.',
  'whyUs.reason5.title': 'Visaptverošs Atbalsts',
  'whyUs.reason5.desc': 'Pilns atbalsts no importa, izplatīšanas līdz juridiskajām un nodokļu konsultācijām.',
  'whyUs.reason6.title': 'Ilgtermiņa Partnerība',
  'whyUs.reason6.desc': 'Mēs apņemamies ilgtermiņa partnerībai un ilgtspējīgai attīstībai kopā ar partneriem.',

  // Contact Section
  'contact.title': 'Gatavi Eksportēt uz Baltiju un Ziemeļeiropu?',
  'contact.description': 'Sazinieties ar mums jau šodien, lai saņemtu detalizētas konsultācijas par eksporta pakalpojumiem.',
  'contact.form.name': 'Vārds un Uzvārds',
  'contact.form.namePlaceholder': 'Ievadiet savu vārdu',
  'contact.form.company': 'Uzņēmuma Nosaukums',
  'contact.form.companyPlaceholder': 'Ievadiet uzņēmuma nosaukumu',
  'contact.form.phone': 'Tālruņa Numurs',
  'contact.form.phonePlaceholder': 'Ievadiet tālruņa numuru',
  'contact.form.email': 'E-pasts',
  'contact.form.emailPlaceholder': 'Ievadiet e-pastu',
  'contact.form.product': 'Produktu Kategorija',
  'contact.form.productPlaceholder': 'Ievadiet produktu kategoriju, ko vēlaties eksportēt',
  'contact.form.message': 'Ziņojums',
  'contact.form.messagePlaceholder': 'Pastāstiet mums par savām eksporta vajadzībām...',
  'contact.form.submit': 'Nosūtīt Pieprasījumu',
  'contact.form.submitting': 'Nosūta...',
  'contact.success': 'Pieprasījums nosūtīts veiksmīgi! Mēs sazināsimies ar jums drīzumā.',
  'contact.error': 'Radās kļūda. Lūdzu, mēģiniet vēlreiz.',

  // Export Services Section
  'services.sectionTitle': 'Pilns Risinājums',
  'services.sectionTitleHighlight': 'Eksporta Partneriem',

  // Export Process Section
  'process.sectionTitle': '6 Vienkārši Soļi',
  'process.sectionTitleHighlight': 'Eksportam uz ES',
  'process.stepLabel': 'Solis',
  'process.stepOf': '/',
  'process.prevBtn': 'Iepriekšējais',
  'process.nextBtn': 'Nākamais',
  'process.step1.duration': '1-3 dienas',
  'process.step2.duration': '3-5 dienas',
  'process.step3.duration': '7-14 dienas',
  'process.step4.duration': '15-30 dienas',
  'process.step5.duration': 'Nepārtraukti',
  'process.step6.duration': 'No 3. mēneša',
  'process.timelineNote': 'Kopējais laiks no līguma parakstīšanas līdz precēm noliktavā:',
  'process.timelineValue': 'tikai 30-45 dienas',

  // Export Contact Section
  'contact.badge': 'Sadarbības Kontakts',
  'contact.formTitle': 'Reģistrēties Eksporta Sadarbībai',
  'contact.formSubtitle': 'Bezmaksas konsultācija — Bez saistībām',
  'contact.hotlineLabel': 'Sadarbības Tālrunis',
  'contact.hotlineSub': 'Whatsapp / Zvans / Viber',
  'contact.emailSub': 'Atbilde 24 stundu laikā',
  'contact.officeLabel': 'Birojs',
  'contact.officeSub': 'Rīga, Latvija, ES',
  'contact.commitmentTitle': 'Mūsu Apņemšanās',
  'contact.commitmentQuote': 'Mēs neesam tikai importētāji — mēs esam stratēģiski partneri, kas pavada Āzijas uzņēmumus, veidojot ilgtspējīgu zīmolu Eiropas tirgū ar 450 miljoniem iedzīvotāju.',
  'contact.companyEstablished': 'Rīga, Latvija — Dibināts 2019',
  'contact.form.country': 'Valsts',
  'contact.form.countryPlaceholder': 'Izvēlieties valsti',
  'contact.form.volume': 'Paredzamais Eksporta Apjoms',
  'contact.form.volumePlaceholder': 'Izvēlieties apjomu',
  'contact.form.privacyNote': 'Nosūtot formu, jūs piekrītat, ka mēs ar jums sazināsimies konsultāciju nolūkos. Informācija tiek stingri aizsargāta.',
  'contact.countries.vietnam': 'Vjetnama',
  'contact.countries.china': 'Ķīna',
  'contact.countries.thailand': 'Taizeme',
  'contact.countries.japan': 'Japāna',
  'contact.countries.korea': 'Dienvidkoreja',
  'contact.countries.indonesia': 'Indonēzija',
  'contact.countries.malaysia': 'Malaizija',
  'contact.countries.philippines': 'Filipīnas',
  'contact.countries.india': 'Indija',
  'contact.countries.other': 'Cita',
  'contact.categories.food': 'Pārtika un dzērieni',
  'contact.categories.spices': 'Garšvielas un mērces',
  'contact.categories.noodles': 'Nūdeles un sausās nūdeles',
  'contact.categories.snacks': 'Uzkodas un konfektes',
  'contact.categories.consumer': 'Patēriņa preces',
  'contact.categories.cosmetics': 'Kosmētika un personīgā aprūpe',
  'contact.categories.household': 'Mājsaimniecības preces',
  'contact.categories.other': 'Cits',
  'contact.volumes.under1': 'Mazāk par 1 konteineru/mēnesī',
  'contact.volumes.1to3': '1-3 konteinerus/mēnesī',
  'contact.volumes.3to5': '3-5 konteinerus/mēnesī',
  'contact.volumes.over5': 'Vairāk par 5 konteineriem/mēnesī',
};